export default "__VITE_ASSET__d1267b1f__"